import { styled } from "@mui/material/styles";
import { Box, Typography, } from "@mui/material";
// Styled components
var Container = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        display: "flex",
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
    });
});
var Sidebar = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        width: "16rem",
        borderRight: "1px solid ".concat(theme.palette.divider),
        padding: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
    });
});
var NavSection = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
    });
});
var NavItemContainer = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "active"; },
})(function (_a) {
    var theme = _a.theme, active = _a.active;
    return ({
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        padding: theme.spacing(0.75, 1),
        borderRadius: theme.shape.borderRadius,
        fontSize: "0.875rem",
        cursor: "pointer",
        color: active ? theme.palette.primary.main : theme.palette.text.primary,
        backgroundColor: active ? "".concat(theme.palette.primary.main, "10") : "transparent",
        fontWeight: active ? 500 : 400,
        "&:hover": {
            backgroundColor: active ? "".concat(theme.palette.primary.main, "10") : theme.palette.action.hover,
        },
    });
});
var SectionTitle = styled(Typography)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: "0.75rem",
        fontWeight: 500,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1),
    });
});
var ContentContainer = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        flex: 1,
        padding: theme.spacing(3),
    });
});
export { Container, Sidebar, NavSection, NavItemContainer, SectionTitle, ContentContainer, };
